import { useEffect, useState } from "react";
import { fetchFeatureFlag } from "utils/firebaseFeatureFlags";

export const useFirebaseFeatureFlag = (flagKey) => {
  const [flagValue, setFlagValue] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  useEffect(() => {
    const checkFlag = async () => {
      setIsLoading(true);
      const flag = await fetchFeatureFlag(flagKey);
      setFlagValue(flag);
      setIsLoading(false);
    };
    checkFlag();
  }, []);

  return { flagValue, isLoading };
};
